
<script>

    import { _ } from "svelte-i18n";
    import { init, locale } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import UserStore from '../stores/user';
    import { getContext } from 'svelte';
    import PricingPlans from './ai/PricingPlans.svelte';
    import ReturnoPromo from './ReturnoPromo.svelte';

    let customers_count = 0,
        door_count = 0,
        pickup_count = 0,
        productPhone = '',
        productMsg = false,
        showPopupProduct = false,
        returnoPopupShow = false;

    const returnoPopupDismissKey = 'returnoai_promo_dismissed_v4';
    const promoDismissDurationMs = 24 * 60 * 60 * 1000;

    $: shipments_count = door_count + pickup_count;

    let zap_app = (typeof zap === 'undefined' || zap === false) ? false : true;

    let languages = localStorage.getItem('languages');
    languages = languages ? JSON.parse(languages) : [];
    
    const selectedLanguage = getContext('language');
    console.log(selectedLanguage)
    let language = 'he';

    onMount(() => {


        const savedLanguage = localStorage.getItem('language');
        const promoDismissRaw = localStorage.getItem(returnoPopupDismissKey);
        const promoDismissTime = Number.parseInt(promoDismissRaw || '', 10);
        const promoDismissed = Number.isFinite(promoDismissTime) && (Date.now() - promoDismissTime) < promoDismissDurationMs;

        if (!promoDismissed) {
            returnoPopupShow = true;
        }

        if (savedLanguage && languages.find(lang => lang.code === savedLanguage)) {
            language = savedLanguage;
            locale.set(savedLanguage);
        } else {
            // Default to Hebrew if no valid saved language
            localStorage.setItem('language', 'he');
            locale.set('he');
        }
    });

    // Handle language change
    function handleLanguageChange(event) {
        const newLanguage = event.target.value;
        language = newLanguage;
        localStorage.setItem('language', newLanguage);
        selectedLanguage.set(newLanguage);
        locale.set(newLanguage);
    }


    const closePopup = ()=> {
        showPopupProduct = !showPopupProduct;
    }

    function closeReturnoPromo() {
        returnoPopupShow = false;
        localStorage.setItem(returnoPopupDismissKey, String(Date.now()));
    }

</script>
{#if showPopupProduct}
<div class="popup fixed top-0 left-0 m-auto w-full h-full bg-stone-300/[.6] flex items-center justify-center flex-col" style="z-index:100;">
    <PricingPlans on:closePopup={closePopup}/>
    <!-- <div class="bg-white rounded-[5px] px-5 py-5 w-[400px] text-[14px] relative text-center">
        <div class="close absolute top-0 left-0 cursor-pointer p-5" on:click={()=>showPopupProduct = false}>X</div>
        <h4 class="text-[16px] mb-2 font-bold">{$_('notification_product_popup.title')}</h4>
        {#if productMsg==false}
        <div class="text-start">
            {@html $_('notification_product_popup.description')}
        </div>
        <div class="my-3 text-start">
            <label class="text-start font-bold">{$_('notification_product_popup.phone')}</label>
            <input type="text" class="w-full border border-gray-300 rounded-[5px] p-2 mt-1" placeholder="{$_('notification_product_popup.phone')}" bind:value={productPhone} />
        </div>                
        <div class="bg-black text-white rounded-[5px] p-2 mt-1 cursor-pointer text-center" on:click={()=> { productReg()}}>{$_('notification_product_popup.register')}</div>
        {:else}
        <div class="text-center text-red-600 font-bold">
            {@html $_('notification_product_popup.thank_you')}
        </div>
        {/if}
    </div> -->
</div>
{/if}
<div class="dash-top flex justify-end">
    <div class="flex justify-between gap-2 w-full">
        {#if zap_app}
        <div class="box flex justify-start items-center gap-2">
            <img src="{siteUrl}images/zap.png" alt="Zap Icon" class="w-8 h-8" />
        </div>
        {/if}
        <div class="returno-inline-slot">
            <ReturnoPromo show={returnoPopupShow} on:close={closeReturnoPromo} />
        </div>
        <!-- <div class="flex justify-start items-center gap-2">
            <div class="px-4">
                <i class="fa-solid fa-fire text-orange-500"></i>
                <strong>{$_('header.notifications_mark')}</strong>
                <span>{$_('header.notifications_text')}</span>
                <button on:click={() => { showPopupProduct = !showPopupProduct; }  } class="bg-blue-700 text-white px-3 py-1 mx-2 rounded-md hover:bg-blue-800 transition-colors">{$_('header.get_started')}</button>
            </div>
        </div> -->
        <div class="box flex justify-end items-center gap-2 ms-auto">
            <i class="fa-solid fa-earth-americas"></i>
            <select 
                bind:value={language} 
                on:change={handleLanguageChange}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                    focus:ring-blue-500 focus:border-blue-500 p-1.5"
            >
                {#each languages as language}
                    <option value={language.code}>{language.name}</option>
                {/each}
            </select>
        </div>
    </div>
</div>
{#if shippingo==1000}
<div class="dash-top">
    <div class="box">
        <div><i class="fa-solid fa-chart-simple"></i> {$_('dash.statics')}</div>
    </div>
    <div class="box">
        <div>{$_('dash.shipments')}</div>
        <div>{shipments_count}</div>
        <!-- <div class="canvas-container">
            <canvas id="myChart"></canvas>
        </div> -->
    </div>
    <!-- <div class="box">
        <div>{$_('dash.returns')}</div>
        <div>{customers_count}</div>
    </div> -->
    <div class="box">
        <div>{$_('dash.door')}</div>
        <div>{door_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
    <div class="box">
        <div>{$_('dash.pickup')}</div>
        <div>{pickup_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
</div>
{/if}
{#if $UserStore.blocked==1}
<div class="dash-top-notification">
    {$_('notification.errors.blocked')}
    {#if shippingo=="0" || shippingo=="2"}
    <a href="mailto:tal@datalogics.co.il">tal@datalogics.co.il</a>
    {:else}
    <a href="mailto:info@shippingo.ai">info@shippingo.ai</a>
    {/if}    
</div>
{/if}
{#if $UserStore.errors}
    {#each $UserStore.errors as error} 
    <div class="dash-top-notification">
        {error.msg}
    </div>
    {/each}
{/if}
<style>
    .dash-top-notification {
        background-color: var(--theme-one-color);
        color: white;
        text-align: center;
        font-size: 13px;
        padding: 10px;
    }
    .canvas-container {
        width: 200px;;
        height: 70px;
    }
    .dash-top{
        display: flex;
        gap:20px;
        /* justify-content: space-between; */
        box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
        background-color: #fff;;
        
    }
    .dash-top .box{
        border-radius: 7px;
        /* border: 1px solid #e4e4e4;
        border: 3px solid rgb(244, 247, 249); */
        padding:10px 20px;
        width: 200px;
        text-align: center;
        background-color: #fff;;
        font-size:15px;      
        display: flex;
        gap:10px;  
    }

    .returno-inline-slot {
        flex: 1;
        min-width: 0;
        display: flex;
    }

    @media screen and (max-width:600px) {

        .dash-top {
            height: 38px;;
        }
        .dash-top .box {
            display: none;;
            
        }
    }
    /* .dash-top .box > div:last-child {
        font-size:20px;
    } */
</style>